import React from 'react';

interface ExpandSvgProps {
  className?: string;
  style?: React.CSSProperties;
}

export const ExpandSvg: React.FC<ExpandSvgProps> = ({ className, style }) => {
  return (
    <svg 
      width="14" 
      height="14" 
      viewBox="0 0 14 14" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path d="M2 0H7V2H14V4H7V6H2V4H0V2H2V0Z" fill="currentColor"/>
      <path d="M12 12H14V10H12V8H7V10H0V12H7V14H12V12Z" fill="currentColor"/>
    </svg>
  );
}; 